import React, { useEffect, useState } from 'react';
import axiosInstance from '../axiosConfig';


import { Link, useLocation } from 'react-router-dom';
import Sidebar from '../Components/Sidebar';
import Header from '../Components/Header';

function AddEmployee() {
  const [message, setMessage] = useState('');
  const location = useLocation();
  const activePath = location.pathname;

  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const userId = localStorage.getItem('id');
    if (!userId) return;

    axiosInstance
      .get(`/user/${userId}/`)
      .then((res) => setCurrentUser(res.data))
      .catch(() => setCurrentUser(null));
  }, []);


  // Main form
  const [formDocumentData, setFormDocumentData] = useState({
    employee_code: '',
    contact_number: '',
    email: '',
    first_name: '',
    middle_name: '',
    last_name: '',
    father_first_name: '',
    father_middle_name: '',
    father_last_name: '',
    gender: '',
    date_of_birth: '',
    department: '',
    position: '',
    address: '',
    date_of_joining: '',
    offer_date: '',
  });

  const [department, setDepartment] = useState('');
  const selectedBranch = localStorage.getItem('selectedBranch');

  // Inline Address form state
  const [addressLine1, setAddressLine1] = useState('');
  const [addressLine2, setAddressLine2] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [pincode, setPincode] = useState('');


  const [salary, setSalary] = useState({
    basic: '',
    da: '',
    hra: '',
    bonus: '',
    special_allowance: '',
    other1: '',
    other2: '',
  });

  const [epfEnabled, setEpfEnabled] = useState(true);
  const [esicEnabled, setEsicEnabled] = useState(true);

  const handleSalaryChange = (e) => {
    const value = e.target.value === '' ? '' : Number(e.target.value);
    setSalary((prev) => ({ ...prev, [e.target.name]: value }));
  };

  const safe = (v) => (v === '' || v === null || v === undefined ? 0 : Number(v));

  const isSalaryAdded = Object.values(salary).some((v) => v !== '' && v !== 0);

  const grossTotal =
    safe(salary.basic) +
    safe(salary.da) +
    safe(salary.hra) +
    safe(salary.bonus) +
    safe(salary.special_allowance) +
    safe(salary.other2);

  const cappedBasic = Math.min(safe(salary.basic), 15000);

  const employeeEPF = epfEnabled ? Math.round(cappedBasic * 0.12) : 0;
  const employerEPF = epfEnabled ? Math.round(cappedBasic * 0.13) : 0;

  const employeeESIC =
    esicEnabled && grossTotal <= 21000 ? Math.round(grossTotal * 0.0075) : 0;

  const employerESIC =
    esicEnabled && grossTotal <= 21000 ? Math.round(grossTotal * 0.0325) : 0;

  const takeHome = grossTotal - employeeEPF - employeeESIC - safe(salary.other1);

  const ctc = grossTotal + employerEPF + employerESIC;

  const saveSalaryData = () => {
    if (!isSalaryAdded) return;

    const salaryToSave = {
      ...salary,
      gross_total: grossTotal,
      employee_epf: employeeEPF,
      employee_esic: employeeESIC,
      take_home: takeHome,
      employer_epf: employerEPF,
      employer_esic: employerESIC,
      ctc,
      epf_enabled: epfEnabled,
      esic_enabled: esicEnabled,
    };

    setFormDocumentData((prev) => ({ ...prev, ...salaryToSave }));
  };

  // Helpers
  const handleDocumentChange = (event) => {
    const { name, value } = event.target;
    setFormDocumentData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    const storedDepartment = localStorage.getItem('selectedDepartment');
    if (storedDepartment) {
      setDepartment(storedDepartment);
      setFormDocumentData((prev) => ({ ...prev, department: storedDepartment }));
    }
  }, []);

  const handleDocumentSubmit = async (event) => {
    event.preventDefault();
    setMessage('');

    const payload = new FormData();
    payload.append('email', formDocumentData.email);
    payload.append('first_name', formDocumentData.first_name);
    payload.append('middle_name', formDocumentData.middle_name);
    payload.append('last_name', formDocumentData.last_name);
    payload.append('contact_number', formDocumentData.contact_number);
    payload.append('employee_code', formDocumentData.employee_code);
    payload.append('department', department || formDocumentData.department);
    payload.append('branch', selectedBranch);
    payload.append('date_of_birth', formDocumentData.date_of_birth);
    payload.append('gender', formDocumentData.gender);
    payload.append('father_first_name', formDocumentData.father_first_name);
    payload.append('father_middle_name', formDocumentData.father_middle_name);
    payload.append('father_last_name', formDocumentData.father_last_name);
    payload.append('position', formDocumentData.position);
    payload.append('address', formDocumentData.address);
    payload.append('date_of_joining', formDocumentData.date_of_joining);
    payload.append('offer_date', formDocumentData.offer_date);

    if (isSalaryAdded) {
      payload.append('basic', formDocumentData.basic);
      payload.append('da', formDocumentData.da);
      payload.append('hra', formDocumentData.hra);
      payload.append('bonus', formDocumentData.bonus);
      payload.append('special_allowance', formDocumentData.special_allowance);
      payload.append('other1', formDocumentData.other1);
      payload.append('other2', formDocumentData.other2);

      payload.append('gross_total', formDocumentData.gross_total);
      payload.append('employee_epf', formDocumentData.employee_epf);
      payload.append('employee_esic', formDocumentData.employee_esic);
      payload.append('take_home', formDocumentData.take_home);
      payload.append('employer_epf', formDocumentData.employer_epf);
      payload.append('employer_esic', formDocumentData.employer_esic);
      payload.append('ctc', formDocumentData.ctc);

      payload.append('epf_enabled', formDocumentData.epf_enabled);
      payload.append('esic_enabled', formDocumentData.esic_enabled);
    }

    try {
      await axiosInstance.post('/documents/', payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      setMessage('Employee added successfully!');

      // reset UI state to match the tested workflow (prevents stale salary/address re-submit)
      setFormDocumentData({
        employee_code: '',
        contact_number: '',
        email: '',
        first_name: '',
        middle_name: '',
        last_name: '',
        father_first_name: '',
        father_middle_name: '',
        father_last_name: '',
        gender: '',
        date_of_birth: '',
        department: '',
        position: '',
        address: '',
        date_of_joining: '',
        offer_date: '',
      });

      setAddressLine1('');
      setAddressLine2('');
      setSelectedState('');
      setPincode('');

      setSalary({
        basic: '',
        da: '',
        hra: '',
        bonus: '',
        special_allowance: '',
        other1: '',
        other2: '',
      });

      setEpfEnabled(true);
      setEsicEnabled(true);
    } catch (error) {
      if (error.response?.data) {
        const errorMessages = Object.entries(error.response.data)
          .map(([key, value]) => (Array.isArray(value) ? value.join(', ') : value))
          .join(', ');
        setMessage(errorMessages);
      } else {
        setMessage('An error occurred. Please try again.');
      }
    }
  };

  const states = [
    'Andhra Pradesh',
    'Arunachal Pradesh',
    'Assam',
    'Bihar',
    'Chhattisgarh',
    'Delhi',
    'Goa',
    'Gujarat',
    'Haryana',
    'Himachal Pradesh',
    'Jharkhand',
    'Karnataka',
    'Kerala',
    'Madhya Pradesh',
    'Maharashtra',
    'Manipur',
    'Meghalaya',
    'Mizoram',
    'Nagaland',
    'Odisha',
    'Punjab',
    'Rajasthan',
    'Sikkim',
    'Tamil Nadu',
    'Telangana',
    'Tripura',
    'Uttar Pradesh',
    'Uttarakhand',
    'West Bengal',
    'Jammu & Kashmir',
    'Ladakh',
  ];

  return (
    <div className="dashboard-wrapper">
              {/* Left Sidebar */}
              <div className="dashboard-sidebar">
      <div className="sidebar-header">
        <img src="/logo.png" alt="Logo" className="sidebar-logo" />
      </div>
    
      <nav className="sidebar-nav">
        <Link
          to="/admin-dashboard"
          className={`sidebar-link ${activePath === '/admin-dashboard' ? 'active' : ''}`}
        >
          <i className="fas fa-home"></i> Dashboard
        </Link>
    
        {currentUser?.role_name === 'admin' && (
          <Link
            to="/users"
            className={`sidebar-link ${activePath === '/users' ? 'active' : ''}`}
          >
            <i className="fas fa-users"></i> Users
          </Link>
        )}
    
        {/* Simplified Departments Link */}
        <Link
          to="/departments"
          className={`sidebar-link ${activePath === '/departments' ? 'active' : ''}`}
        >
          <i className="fas fa-file-alt"></i> Departments
        </Link>
      </nav>
    </div>

    <div
                  className="dashboard-main"
                  style={{
                    display: 'flex',
                    gap: '20px',
                    flexWrap: 'nowrap',
                    alignItems: 'flex-start',
                    padding: '20px',
                  }}
                >
                   <div className="dashboard-content" style={{ flex: 3 }}>
    <div className="add-employee-page" style={{ maxHeight: 'calc(100vh - 60px)', overflowY: 'auto' }}>
      <form onSubmit={handleDocumentSubmit}>
        <div className="doc">
          <h2>Add Employees</h2>
        </div>
        <hr />

        <div className="form-row1">

          <div className="form-group">
            <label className="user-label">Employee Code*</label>
            <input
              type="text"
              name="employee_code"
              value={formDocumentData.employee_code}
              onChange={handleDocumentChange}
              required
            />
          </div>

          <div className="form-group">
            <label className="user-label">Contact Number*</label>
            <input
              type="text"
              name="contact_number"
              value={formDocumentData.contact_number}
              onChange={handleDocumentChange}
              maxLength="10"
              inputMode="numeric"
              onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
              required
            />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formDocumentData.email}
              onChange={handleDocumentChange}
            />
          </div>
        </div>

        <div className="form-row1">
          <div className="form-group">
            <label>First Name*</label>
            <input
              type="text"
              name="first_name"
              value={formDocumentData.first_name}
              onChange={handleDocumentChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Middle Name</label>
            <input
              type="text"
              name="middle_name"
              value={formDocumentData.middle_name}
              onChange={handleDocumentChange}
            />
          </div>

          <div className="form-group">
            <label>Last Name</label>
            <input
              type="text"
              name="last_name"
              value={formDocumentData.last_name}
              onChange={handleDocumentChange}
            />
          </div>
        </div>

        <div className="form-row1">
          <div className="form-group">
            <label className="user-label">Father's First Name*</label>
            <input
              type="text"
              name="father_first_name"
              value={formDocumentData.father_first_name}
              onChange={handleDocumentChange}
              required
            />
          </div>

          <div className="form-group">
            <label className="user-label">Father's Middle Name</label>
            <input
              type="text"
              name="father_middle_name"
              value={formDocumentData.father_middle_name}
              onChange={handleDocumentChange}
            />
          </div>

          <div className="form-group">
            <label className="user-label">Father's Last Name</label>
            <input
              type="text"
              name="father_last_name"
              value={formDocumentData.father_last_name}
              onChange={handleDocumentChange}
            />
          </div>
        </div>

        <div className="form-row1">
          <div className="form-group">
            <label>Date Of Birth*</label>
            <input
              type="date"
              name="date_of_birth"
              value={formDocumentData.date_of_birth}
              onChange={handleDocumentChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Gender*</label>
            <div className="select">
              <select
                name="gender"
                value={formDocumentData.gender}
                onChange={handleDocumentChange}
                required
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
            </div>
          </div>

          <div className="form-group">
            <label>Date Of Joining*</label>
            <input
              type="date"
              name="date_of_joining"
              value={formDocumentData.date_of_joining}
              onChange={handleDocumentChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Offer Date*</label>
            <input
              type="date"
              name="offer_date"
              value={formDocumentData.offer_date}
              onChange={handleDocumentChange}
              required
            />
          </div>

          <div className="form-group">
            <label className="user-label">Position*</label>
            <input
              type="text"
              name="position"
              value={formDocumentData.position}
              onChange={handleDocumentChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Department</label>
            <input type="text" name="department" value={department} disabled />
          </div>
        </div>

        <div className="form-row1">
          <div className="form-group">
            <label>Branch</label>
            <input type="text" name="branch" value={selectedBranch || ''} disabled />
          </div>
          </div>

          <div style={{ width: '100%', marginTop: 16 }}>
            <hr style={{ border: 'none', borderTop: '1px solid #ddd' }} />
            <div className="form-group" style={{ marginTop: 12 }}>
              <label className="user-label">Address*</label>


              <div className="form-row1" style={{ marginTop: 8 }}>
                <div className="form-group" style={{ flex: 1 }}>
                  <label>Address Line 1</label>
                  <input
                    type="text"
                    value={addressLine1}
                    onChange={(e) => setAddressLine1(e.target.value)}
                    
                  />
              </div>

              <div className="form-group" style={{ flex: 1 }}>
                <label>Address Line 2</label>
                <input
                  type="text"
                  value={addressLine2}
                  onChange={(e) => setAddressLine2(e.target.value)}
                />
              </div>
            </div>

            <div className="form-row1">
              <div className="form-group" style={{ flex: 1 }}>
                <label>Pincode</label>
                <input
                  type="text"
                  value={pincode}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,6}$/.test(value)) {
                      setPincode(value);
                    }
                  }}
                  maxLength="6"
                  
                />
              </div>

              <div className="form-group" style={{ flex: 1 }}>
                <label>State</label>
                <select
                  value={selectedState}
                  onChange={(e) => setSelectedState(e.target.value)}
                  
                >
                  <option value="">Select State</option>
                  {states.map((state) => (
                    <option key={state} value={state}>
                      {state}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <button
              type="button"
              className="submit-all-btn"
              onClick={() => {
                // Match the tested Documents.js behavior: include pincode in address string
                const fullAddress = `${addressLine1}, ${addressLine2 ? addressLine2 + ', ' : ''}${selectedState} - ${pincode}`;
                setFormDocumentData((prev) => ({ ...prev, address: fullAddress }));
              }}
              style={{ marginTop: 8 }}
            >
              Save Address
            </button>

            {formDocumentData.address && (
              <p style={{ fontSize: '12px', color: 'green', marginTop: 6 }}>
                Address Added ✔
              </p>
            )}
          </div>

          <div className="form-group">
          <hr style={{ border: 'none', borderTop: '1px solid #ddd' }} />
            <label className="user-label">Salary</label>

            <table className="salary-table" style={{ marginTop: 8 }}>
              <thead>
                <tr>
                  <th>Particulars</th>
                  <th>Monthly (₹)</th>
                  <th>Annual (₹)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>BASIC</strong></td>
                  <td>
                    <input
                      type="number"
                      name="basic"
                      value={salary.basic}
                      onChange={handleSalaryChange}
                    />
                  </td>
                  <td>{safe(salary.basic) * 12}</td>
                </tr>

                <tr>
                  <td><strong>DA</strong></td>
                  <td>
                    <input type="number" name="da" value={salary.da} onChange={handleSalaryChange} />
                  </td>
                  <td>{safe(salary.da) * 12}</td>
                </tr>

                <tr>
                  <td><strong>HRA</strong></td>
                  <td>
                    <input type="number" name="hra" value={salary.hra} onChange={handleSalaryChange} />
                  </td>
                  <td>{safe(salary.hra) * 12}</td>
                </tr>

                <tr>
                  <td><strong>Bonus</strong></td>
                  <td>
                    <input type="number" name="bonus" value={salary.bonus} onChange={handleSalaryChange} />
                  </td>
                  <td>{safe(salary.bonus) * 12}</td>
                </tr>

                <tr>
                  <td><strong>Special Allowance</strong></td>
                  <td>
                    <input
                      type="number"
                      name="special_allowance"
                      value={salary.special_allowance}
                      onChange={handleSalaryChange}
                    />
                  </td>
                  <td>{safe(salary.special_allowance) * 12}</td>
                </tr>

                <tr>
                  <td><strong>Gross Total</strong></td>
                  <td><strong>{grossTotal}</strong></td>
                  <td><strong>{grossTotal * 12}</strong></td>
                </tr>

                <tr>
                  <td>
                    Employee EPF (12%)
                    <span
                      onClick={() => setEpfEnabled(!epfEnabled)}
                      style={{ cursor: 'pointer', marginLeft: 10 }}
                    >
                      {epfEnabled ? '✔' : '✖'}
                    </span>
                  </td>
                  <td>{epfEnabled ? employeeEPF : 0}</td>
                  <td>{epfEnabled ? employeeEPF * 12 : 0}</td>
                </tr>

                <tr>
                  <td>
                    Employee ESIC (0.75%)
                    <span
                      onClick={() => setEsicEnabled(!esicEnabled)}
                      style={{ cursor: 'pointer', marginLeft: 10 }}
                    >
                      {esicEnabled ? '✔' : '✖'}
                    </span>
                  </td>
                  <td>{esicEnabled ? employeeESIC : 0}</td>
                  <td>{esicEnabled ? employeeESIC * 12 : 0}</td>
                </tr>

                <tr>
                  <td><strong>Other 1</strong></td>
                  <td>
                    <input type="number" name="other1" value={salary.other1} onChange={handleSalaryChange} />
                  </td>
                  <td>{safe(salary.other1) * 12}</td>
                </tr>

                <tr>
                  <td><strong>Take Home</strong></td>
                  <td><strong>{takeHome}</strong></td>
                  <td><strong>{takeHome * 12}</strong></td>
                </tr>

                <tr>
                  <td>
                    Employer EPF (13%)
                    <span
                      onClick={() => setEpfEnabled(!epfEnabled)}
                      style={{ cursor: 'pointer', marginLeft: 10 }}
                    >
                      {epfEnabled ? '✔' : '✖'}
                    </span>
                  </td>
                  <td>{epfEnabled ? employerEPF : 0}</td>
                  <td>{epfEnabled ? employerEPF * 12 : 0}</td>
                </tr>

                <tr>
                  <td>
                    Employer ESIC (3.25%)
                    <span
                      onClick={() => setEsicEnabled(!esicEnabled)}
                      style={{ cursor: 'pointer', marginLeft: 10 }}
                    >
                      {esicEnabled ? '✔' : '✖'}
                    </span>
                  </td>
                  <td>{esicEnabled ? employerESIC : 0}</td>
                  <td>{esicEnabled ? employerESIC * 12 : 0}</td>
                </tr>

                <tr>
                  <td><strong>Other 2</strong></td>
                  <td>
                    <input type="number" name="other2" value={salary.other2} onChange={handleSalaryChange} />
                  </td>
                  <td>{safe(salary.other2) * 12}</td>
                </tr>

                <tr>
                  <td><strong>CTC</strong></td>
                  <td><strong>{ctc}</strong></td>
                  <td><strong>{ctc * 12}</strong></td>
                </tr>
              </tbody>
            </table>

            <button
              className="submit-all-btn"
              type="button"
              onClick={saveSalaryData}
              style={{ marginTop: 8 }}
            >
              Save Salary
            </button>

            {isSalaryAdded && (
              <p style={{ fontSize: '12px', color: 'green', marginTop: 6 }}>
                Salary Added ✔
              </p>
            )}
          </div>
        </div>

        <hr />
        <button className="submit-all-btn" type="submit">
          Add Employees
        </button>

        {message && <p style={{ color: 'red' }}>{message}</p>}
      </form>
    </div>
    </div>
    </div>
    </div>
  );
}

export default AddEmployee;

